import CategoryNav from "../../components/CategoryNav";
import ProductCollectionPreview from "../../components/ProductCollectionPreview"

const Homepage = () => {
    return (
        <div>
            <CategoryNav />
            <ProductCollectionPreview />
        </div>
    );
};

export default Homepage;